/* eslint-disable max-len */
import React, { useState } from 'react';
import ProfileTitle from '../customerDetail/CustomerProfile/ProfileTitle';
import ProfileLabelAndTitle from '../../components/ProfileLabelAndTitle';
// import SummaryDetailsCover from '../../components/SummaryDetailsCover';
// import NewActiveCheckIcon from '../../svgs/NewActiveCheckIcon';

interface ITransactionRequestDetails{
  payload?: any;
  index: number;
}

const TransactionRequestDetails: React.FC<ITransactionRequestDetails> = ({ payload, index }) => {
  const [showTransactionDetail, setShowTransactionDetail] = useState(false);

  return (
    <div>

      {/* <div className="total-amount-and-div">
        <div className="tnx-check-sapan"><NewActiveCheckIcon /></div>
        <div className="tnx-total-span">
          <span className="value">{payload?.total}</span>
        </div>
        <span className={payload?.status ? payload.status : ''}>{payload?.status}</span>
      </div> */}
      <ProfileTitle
        name="Transaction details"
        index={index}
        onClick={() => setShowTransactionDetail(!showTransactionDetail)}
        hasViewOnlyTab
      />
      {showTransactionDetail && (
        <>
          <ProfileLabelAndTitle
            content={payload}
            attribute={['amount', 'fees', 'landlord', 'paymentMethod', 'txRef', 'createdDate', 'propertyAddress']}
            label={{
              amount: 'Amount',
              fees: 'Fees',
              landlord: 'Landlord',
              txRef: 'Reference No',
              paymentMethod: 'Payment Method',
              createdDate: 'Transaction Date',
              propertyAddress: 'Property Address',
            }}
          />
        </>
      )}

    </div>
  );
};

export default TransactionRequestDetails;
